import axios from 'axios';

export const getApiBaseUrl = () => {
  const configured = process.env.REACT_APP_API_URL;
  if (configured) return configured.replace(/\/$/, '');
  const { hostname, origin } = window.location;
  if (['localhost', '127.0.0.1', '[::1]'].includes(hostname)) {
    return 'http://localhost:8001/bbgapi';
  }
  if (['bbgfood.com', 'www.bbgfood.com'].includes(hostname)) {
    return `${origin}/bbgapi`;
  }
  return 'https://www.bbgfood.com/bbgapi';
};

const ApiClient = axios.create({
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

ApiClient.interceptors.request.use((config) => {
  config.baseURL = getApiBaseUrl();
  const token = localStorage.getItem("authToken");
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default ApiClient;
